import React from 'react'

import * as Yup from 'yup'
import { Form, Select } from 'formik-antd'
import { BasicForm } from '../../../../core/components/form'
import { usePostForm } from '../../../../hooks/admin/languagePair'
import { useCacheLanguage, getLanguagesForSelect } from '../../../../hooks/cache/language'
import { useHistory } from 'react-router-dom'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'

const ValidationSchema = Yup.object().shape({
  sourceLanguage: Yup.string().required('Cannot be blank.'),
  targetLanguage: Yup.string()
    .when('sourceLanguage', (sourceLanguage, schema) => {
      return schema.test({
        test: (targetLanguage) => !!sourceLanguage && !!targetLanguage && sourceLanguage != targetLanguage,
        message: 'Must be different'
      })
    })
    .required('Cannot be blank.')
})

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

const Formulario = () => {
  const create = usePostForm()
  const history = useHistory()

  const { data: languageData } = useCacheLanguage()
  const languages = getLanguagesForSelect(languageData)

  const onPressBack = () => history.goBack()

  function handleSubmit (values, bag) {
    const form = { ...values }

    create.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const initialValues = {
    sourceLanguage: '',
    targetLanguage: ''
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='LANGUAGE PAIR'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      render={() => (
        <>
          <Form.Item
            label='Source Language'
            name='sourceLanguage'
            hasFeedback
            showValidateSuccess
            required
          >
            <Select
              placeholder='Source Language'
              name='sourceLanguage'
              showSearch
              options={languages}
              filterOption={_filter}
            />
          </Form.Item>
          <Form.Item
            label='Target Language'
            name='targetLanguage'
            hasFeedback
            showValidateSuccess
            required
          >
            <Select
              placeholder='Target Language'
              name='targetLanguage'
              showSearch
              options={languages}
              filterOption={_filter}
            />
          </Form.Item>
        </>
      )}
    />
  )
}

export default Formulario
